module.exports = __webpack_public_path__ + "static/media/game-cvback.980209ff.png";